import FormTitle from 'components/PageLayout/FormTitle';
import { EnvironmentVariable } from 'enums/curo/EnvironmentVariable';
import { envs } from 'envs';

import styles from './EndPages.module.scss';

const PAGE_TITLE = 'Thank you for your interest.';
const PAGE_DESCRIPTION = (
  <p className={styles.descriptionWrapper}>
    Our records indicate that you already have an open loan with Heights Finance or one of our
    affiliates. Please contact the branch where you opened your loan or call us at{' '}
    <strong>{envs[EnvironmentVariable.CuroInformationPhoneNumber]}</strong> (Mon - Fri 9am – 6:30pm
    Eastern Time, excl. holidays) for additional information on the status of your open loan.
  </p>
);

const ActiveLoanOrPriorChangeOffPage = () => {
  return <FormTitle title={PAGE_TITLE} subTitle={PAGE_DESCRIPTION} />;
};

export default ActiveLoanOrPriorChangeOffPage;
